<template>
    <ValidationProvider :vid="vid" :name="name" :rules="rules" v-slot="{invalid,errors}">
        <input type="text"
                    ref="input"
                    class="form-control"
                    :name="name"
                    :is-valid="invalid"
                    :placeholder="$attrs.placeholder"
                    v-on:input="updateValue($event.target.value)"
                    v-on:keydown="checkKeyCode($event)"
                    :value="value"
                    v-bind:class="{'is-invalid' : hasError(errors)}"
                    :disabled="disabled"
                    >
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { mdbInput } from "mdbvue";

export default {
    name : "NumberField",
    props : {
        vid: String,
        name: String,
        rules : {
            type : [Object, String],
            default : 'required'
        },

        value: {
            required: true,
            type: [Number, String],
            default: 0
        },

        validated: {
            type: Boolean,
            default : false
        },
        show_error: {
            type: Boolean,
            default : false
        },

        labelClass : {
            type : String,
            default : 'col-md-3'
        },
        fieldClass : {
            type : String,
            default : 'col-md-9'
        },
        disabled : {
            type : Boolean,
            default : false
        }

    },
    components : {
        ValidationProvider,
        mdbInput
    },

    data : () => ({
        inputValue : 0
    }),

    methods : {
        isValid(isInvalid,inpt){
            return ((isInvalid === true && inpt === '') || (isInvalid === true && this.validated === true)) ? true : false
        },

        updateValue: function(cVal) {
            this.$refs.input.value = cVal.toString();
            this.inputValue = cVal.toString();
            this.$emit("input", cVal.toString());
        },

        checkKeyCode(evt) {
            var keyCode = evt.which ? evt.which : evt.keyCode;

            // Accept Numbers Only (top row + numpad) + basic navigation keys
            if (
                (keyCode > 47 && keyCode < 58) ||   // 0-9 (keyboard top row)
                (keyCode > 95 && keyCode < 106) ||  // 0-9 (numpad)
                keyCode === 8 ||                    // Backspace
                keyCode === 9 ||                    // Tab
                keyCode === 37 ||                   // Left arrow
                keyCode === 39                      // Right arrow
            ) {
                return true;
            }

            evt.preventDefault();
        },

        hasError(errors){
            return (errors.length > 0) ? true : false
        }
    },

    created() {
        if (this.value) {
            this.inputValue = this.value.toString();
        }
    }
}
</script>
